import clsx from "clsx"
import {Children, isValidElement} from "react"
import "./Numbers.css"

interface NumbersProps extends React.HTMLAttributes<HTMLUListElement> {}

interface NumbersComponents {
    Item: React.FC<NumbersItemProps>
}

const Numbers: React.FC<NumbersProps> & NumbersComponents = props => {
    const {className, children, ...otherProps} = props

    let items: Array<React.ReactElement<NumbersItemProps>> = []
    Children.map(children, (child, index) => {
        if (!isValidElement<NumbersItemProps>(child)) return
        items.push(child)
    })

    return (
        <ul className={clsx("numbers-5xak", className)} {...otherProps}>
            {items.map((item, index) => {
                return (
                    <li key={index} className="item-5xak">
                        <span className="value-5xak">{item.props.value}</span>
                        <span className="description-5xak">{item.props.description}</span>
                    </li>
                )
            })}
        </ul>
    )
}

export default Numbers

interface NumbersItemProps {
    value: string | null | undefined
    description: string | null | undefined
}

const NumbersItem: React.FC<NumbersItemProps> = props => null

Numbers.Item = NumbersItem
